import { usePrettyPublishingPointSearchRegExps, useSearchRegExps } from "@quortex/front-common"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"
import illustrationNoOttEndpoints from "src/App/play/images/illustration-no-ott-endpoints.svg"
import AddOttEndpointButton from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/AddOttEndpointButton"
import OttEndpointTable from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/OttEndpointTable"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"

type Props = {
  row: OttEndpointRow
  hasWriteAccess: boolean
}

const OttEndpointContent: FC<Props> = ({ row, hasWriteAccess }) => {
  const form = useFormContext()
  const searchValue = form.watch("search")
  const searchRegExps = useSearchRegExps(searchValue)
  const prettySearchRegExps = usePrettyPublishingPointSearchRegExps(searchValue)

  if (row.endpoints.length === 0) {
    return (
      <div className="space-y-md px-md py-sm text-center">
        <img alt="illustration of no OTT endpoints" src={illustrationNoOttEndpoints} />
        <p className="text-grey-600">No OTT endpoint has been configured yet.</p>
        {hasWriteAccess && (
          <div className="flex items-center justify-center">
            <AddOttEndpointButton row={row} />
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <div className="cursor-default overflow-x-auto">
        <OttEndpointTable
          endpoints={row.endpoints}
          prettySearchRegExps={prettySearchRegExps}
          searchRegExps={searchRegExps}
        />
      </div>

      {hasWriteAccess && (
        <div className="mt-sm flex items-center justify-end">
          <AddOttEndpointButton row={row} />
        </div>
      )}
    </>
  )
}

export default OttEndpointContent
